import {
  IHit,
  ISearchEmbeddedKeyType,
  ISearchResponse,
} from '@omni/kit/services/SearchService';

import { IAppSearchHit } from '@omni/kit/services/SearchService/AppSearchHitTypes';
import { IMediaItem } from '@omni/kit/services/MediaItemService/Types';
import { ITag } from '@omni/kit/services/TagService/Types';
import { SearchResultItemProps } from '@omni/kit/feeds/searchListItemTypes';
import { convertToListItem } from '@omni/kit/feeds/ListItemConverter';
import pluralize from 'pluralize';
import { IGroup } from '@omni/kit/services/GroupsService/Types';

/**
 * Re-shape hits payload, by creating an array with all the response objects
 * including their type. The `type` is used to format each object into
 * a specific format.
 *
 * @example (type - [app, media-item, media-series, tag:speaker]
 * @param results
 */
export function parseSearchResults(
  results: ISearchResponse
): SearchResultItemProps[] {
  const parsedResponse: IMediaItem[] | ITag[] | IGroup[] = [];
  const embedded = results?.body?._embedded;

  if (embedded && embedded.hits) {
    embedded.hits.forEach((hit: IHit) => {
      if (hit.type) {
        let relationshipName = hit.type;

        let includedObject;

        if (['tag:topic', 'tag:speaker'].includes(relationshipName)) {
          relationshipName = relationshipName?.split(':')[1];
        }

        if (relationshipName === 'app') {
          includedObject = hit;
        } else {
          const key = pluralize(relationshipName) as ISearchEmbeddedKeyType;
          includedObject = embedded[key]?.find((model: any) => {
            if (relationshipName === 'app') {
              return model.id === hit.fields.app_key;
            } else {
              return model.id === hit.id;
            }
          });
        }

        if (includedObject) {
          parsedResponse.push({
            ...includedObject,
            type: relationshipName,
          });
        }
      }
    });
  }

  const listItems: SearchResultItemProps[] = parsedResponse.map(
    (item: IMediaItem | ITag | IAppSearchHit | IGroup) => {
      return convertToListItem(item, item.type);
    }
  );

  return listItems;
}
